export const EXERCISE_IDS = ['greeting', 'empathy', 'hold', 'closing'];

export const scoreExercise = (meta = {}) => {
  if (!meta.recorded) return 0;

  let score = 55;
  const duration = Number(meta.durationSec) || 0;

  if (duration >= 2) score += 10;
  if (duration >= 5) score += 10;
  if (duration >= 10) score += 15;
  if (duration >= 15) score += 10;

  return Math.min(100, score);
};

export const buildAssessmentScores = ({
  exerciseMeta = {},
  englishConfidence = 0,
  completedTraining = ''
} = {}) => {
  const exerciseScores = EXERCISE_IDS.reduce((acc, id) => {
    acc[id] = scoreExercise(exerciseMeta[id] || {});
    return acc;
  }, {});

  const exerciseValues = Object.values(exerciseScores);
  const exerciseAverage = exerciseValues.length
    ? exerciseValues.reduce((sum, value) => sum + value, 0) / exerciseValues.length
    : 0;

  const confidenceScore = (Math.min(10, Math.max(0, Number(englishConfidence) || 0)) / 10) * 100;
  const trainingBonus = completedTraining === 'yes' ? 100 : completedTraining === 'no' ? 25 : 0;

  const overallScore = Math.round(
    (exerciseAverage * 0.65) + (confidenceScore * 0.25) + (trainingBonus * 0.1)
  );

  return {
    exerciseScores,
    overallScore: Math.min(100, Math.max(0, overallScore))
  };
};

export const getScoreGrade = (score) => {
  if (score >= 85) return 'excellent';
  if (score >= 70) return 'good';
  if (score >= 50) return 'fair';
  return 'needs-work';
};
